module.exports = __webpack_public_path__ + "img/traffic-junction-5.1a093e46.webp";